<template>
  <div class="lyf-ui-action-bar-placeholder" :class="{
    'bar-placeholder' : placeholder,
    'save-area': safeAreaInsetBottom
  }">
    <div class="lyf-ui-action-bar" :class="{
      'save-area': safeAreaInsetBottom,
      disabled
    }">
      <slot></slot>
      <div class="lyf-ui-action-button" 
        :style="{
          backgroundColor: buttonBackground
        }"
        @click="buttonClick"
      >{{ buttonText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LyfActionBar',
  props: {
    // 是否在标签位置生成一个等高的占位元素
    placeholder: {
      type: Boolean,
      default: true
    },
    safeAreaInsetBottom: Boolean,
    buttonText: {
      type: String,
      default: '确认'
    },
    buttonBackground: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  methods: {
    buttonClick() {
      if (this.disabled) return
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.lyf-ui-action-bar-placeholder.bar-placeholder {
  height: 56px;
}
.lyf-ui-action-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  padding: 0 var(--space_16);
  background-color: var(--background-color_2);
}
.lyf-ui-action-bar .lyf-ui-action-button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  border-radius: var(--radius_8);
  background-color: var(--action-bar-button-background);
  color: var(--font-color_4);
  font-size: 14px;
  font-weight: 500;
}
.lyf-ui-action-bar-placeholder.save-area,
.lyf-ui-action-bar.save-area {
  padding-bottom: env(safe-area-inset-bottom);
}
.lyf-ui-action-bar.disabled .lyf-ui-action-button {
  opacity: .4;
}
</style>